import React, { useEffect, useState } from 'react';
import styles from './Header.module.css';

const navItems = [
  { label: 'How It Works', href: '#ako-to-funguje' },
  { label: "What's Inside", href: '#produkt' },
];

interface HeaderProps {
  onPrimaryCtaClick: () => void;
}

export function Header({ onPrimaryCtaClick }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`.trim()}>
      <div className={styles.inner}>
        <a href="#hero" className={styles.brand}>
          <img
            src="/logo/logo-with-brand-name.png"
            alt="Green Rituals"
            className={styles.brandLogo}
          />
        </a>

        <div className={styles.rightSide}>
          <nav aria-label="Main navigation">
            <ul className={styles.navList}>
              {navItems.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className={styles.navLink}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <button type="button" className={styles.cta} onClick={onPrimaryCtaClick}>
            Reserve Kit — $49
          </button>
        </div>
      </div>
    </header>
  );
}
